import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ConsentValue = 'unset' | 'granted' | 'denied'

interface CookieConsentState {
    /** Consentimiento para cookies de analítica (Matomo). */
    analytics: ConsentValue
    grantAnalytics: () => void
    denyAnalytics: () => void
}

/**
 * Consentimiento de cookies no esenciales (analítica). Persistido en
 * localStorage. Mientras sea 'unset' se muestra el banner y NO se carga Matomo.
 * (Blindaje legal — ítem 13)
 */
export const useCookieConsent = create<CookieConsentState>()(
    persist(
        (set) => ({
            analytics: 'unset',
            grantAnalytics: () => set({ analytics: 'granted' }),
            denyAnalytics: () => set({ analytics: 'denied' }),
        }),
        { name: 'cookie-consent' },
    ),
)
